import { render, staticRenderFns } from "./Desk.State.Modal.vue?vue&type=template&id=ebb450d2"
import script from "./Desk.State.Modal.vue?vue&type=script&lang=js"
export * from "./Desk.State.Modal.vue?vue&type=script&lang=js"
import style0 from "./Desk.State.Modal.vue?vue&type=style&index=0&id=ebb450d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports